import {
	Card,
	Col,
	message,
	Row,
	Tag,
	Typography,
	Statistic,
	Progress,
	Button,
	Badge,
	DatePicker,
	Select,
	Space,
	Tooltip,
} from "antd";
import { useContext, useEffect, useState } from "react";
import SearchInput from "../../components/SearchInput";
import { useNavigate, useParams } from "react-router";
import {
	PiCloudDuotone,
	PiEnvelopeDuotone,
	PiHardDrivesDuotone,
	PiGlobeDuotone,
	PiShieldCheckDuotone,
	PiCreditCardDuotone,
	PiChartLineDuotone,
	PiUsersDuotone,
	PiWarningDuotone,
	PiCheckCircleDuotone,
	PiClockDuotone,
	PiCubeDuotone,
	PiMoneyDuotone,
	PiGearDuotone,
	PiPlusDuotone,
	PiMonitorDuotone,
	PiArrowClockwiseDuotone,
} from "react-icons/pi";
import AppContext from "../../store/app.context";
import {
	requestGetServiceGroupList,
	requestGetServiceList,
	requestGetUserList,
	requestGetOrderList,
	requestGetOrderStatistics,
	requestGetStatistics,
} from "../../services/admin.service";
import dayjs from "dayjs";
import { formatCurrency } from "../../utils/Formatter";

// const services = [
// 	{
// 		id: 1,
// 		name: "Shared Hosting",
// 		slug: "shared-hosting",
// 		description: "Reliable shared hosting with cPanel",
// 		icon: <PiGlobeDuotone size={32} color="#1890ff" />,
// 		enabled: true,
// 		category: "hosting",
// 		price: "$9.99/month",
// 		activeInstances: 45,
// 		maxInstances: 100,
// 	},
// 	{
// 		id: 2,
// 		name: "VPS Hosting",
// 		slug: "vps-hosting",
// 		description: "Scalable virtual private servers",
// 		icon: <PiHardDrivesDuotone size={32} color="#52c41a" />,
// 		enabled: true,
// 		category: "hosting",
// 		price: "$29.99/month",
// 		activeInstances: 12,
// 		maxInstances: 50,
// 	},
// 	{
// 		id: 3,
// 		name: "Cloud Storage",
// 		slug: "cloud-storage",
// 		description: "Secure cloud storage solutions",
// 		icon: <PiCloudDuotone size={32} color="#722ed1" />,
// 		enabled: true,
// 		category: "storage",
// 		price: "$4.99/month",
// 		activeInstances: 78,
// 		maxInstances: 200,
// 	},
// 	{
// 		id: 4,
// 		name: "Container Deployment",
// 		slug: "container-deployment",
// 		description: "Deploy applications with Docker containers",
// 		icon: <PiCubeDuotone size={32} color="#fa8c16" />,
// 		enabled: true,
// 		category: "deployment",
// 		price: "$19.99/month",
// 		activeInstances: 23,
// 		maxInstances: 75,
// 	},
// 	{
// 		id: 5,
// 		name: "Email Hosting",
// 		slug: "email-hosting",
// 		description: "Professional email hosting service",
// 		icon: <PiEnvelopeDuotone size={32} color="#eb2f96" />,
// 		enabled: true,
// 		category: "email",
// 		price: "$7.99/month",
// 		activeInstances: 89,
// 		maxInstances: 150,
// 	},
// 	{
// 		id: 6,
// 		name: "Database Service",
// 		slug: "database-service",
// 		description: "Managed database solutions",
// 		icon: <PiHardDrivesDuotone size={32} color="#13c2c2" />,
// 		enabled: true,
// 		category: "database",
// 		price: "$15.99/month",
// 		activeInstances: 34,
// 		maxInstances: 100,
// 	},
// 	{
// 		id: 7,
// 		name: "SSL Certificates",
// 		slug: "ssl-certificates",
// 		description: "Secure your websites with SSL",
// 		icon: <PiShieldCheckDuotone size={32} color="#f5222d" />,
// 		enabled: true,
// 		category: "security",
// 		price: "$12.99/year",
// 		activeInstances: 67,
// 		maxInstances: 200,
// 	},
// 	{
// 		id: 8,
// 		name: "Backup Service",
// 		slug: "backup-service",
// 		description: "Automated backup solutions",
// 		icon: <PiClockDuotone size={32} color="#faad14" />,
// 		enabled: false,
// 		category: "backup",
// 		price: "$8.99/month",
// 		activeInstances: 0,
// 		maxInstances: 50,
// 	},
// ];

const serviceIcons = {
	"APLA.DB": <PiHardDrivesDuotone size={32} color="#52c41a" />,
	"APLA.AP": <PiCloudDuotone size={32} color="#722ed1" />,
	"APLA.SV": <PiGearDuotone size={32} color="#FA1680FF" />,
	WEHO: <PiMonitorDuotone size={32} color="#fa8c16" />,
};

// Recent activities
const recentActivities = [
	{
		id: 1,
		type: "order",
		message: "New VPS order from john@example.com",
		time: "2 minutes ago",
		status: "success",
		icon: <PiCheckCircleDuotone color="#52c41a" />,
	},
	{
		id: 2,
		type: "payment",
		message: "Payment received for shared hosting",
		time: "15 minutes ago",
		status: "success",
		icon: <PiCreditCardDuotone color="#1890ff" />,
	},
	{
		id: 3,
		type: "alert",
		message: "Server maintenance scheduled",
		time: "1 hour ago",
		status: "warning",
		icon: <PiWarningDuotone color="#faad14" />,
	},
	{
		id: 4,
		type: "signup",
		message: "New client registration",
		time: "3 hours ago",
		status: "info",
		icon: <PiUsersDuotone color="#722ed1" />,
	},
];

function DashboardPage() {
	const context = useContext(AppContext);
	const navigate = useNavigate();
	const user = context.user;

	const [services, setServices] = useState([]);
	const [serviceGroups, setServiceGroups] = useState([]);
	const [dateRange, setDateRange] = useState([dayjs().startOf("month"), dayjs().endOf("month")]);
	const [selectedDatePreset, setSelectedDatePreset] = useState("thisMonth");
	const [statsLoading, setStatsLoading] = useState(false);

	const [dashboardStats, setDashboardStats] = useState({
		revenue: 0,
		services: 0,
		clients: 0,
		orders: 0,
		invoices: 0,
		uptime: 99.99,
	});

	const [mappedServices, setMappedServices] = useState([]);
	const [selectedServiceGroup, setSelectedServiceGroup] = useState("all");

	// Date range presets
	const datePresets = [
		{
			label: "Today",
			value: "today",
			range: [dayjs().startOf("day"), dayjs().endOf("day")],
		},
		{
			label: "Yesterday",
			value: "yesterday",
			range: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")],
		},
		{
			label: "Last 7 Days",
			value: "last7Days",
			range: [dayjs().subtract(6, "days").startOf("day"), dayjs().endOf("day")],
		},
		{
			label: "Last 30 Days",
			value: "last30Days",
			range: [dayjs().subtract(29, "days").startOf("day"), dayjs().endOf("day")],
		},
		{
			label: "This Week",
			value: "thisWeek",
			range: [dayjs().startOf("week"), dayjs().endOf("week")],
		},
		{
			label: "Last Week",
			value: "lastWeek",
			range: [
				dayjs().subtract(1, "week").startOf("week"),
				dayjs().subtract(1, "week").endOf("week"),
			],
		},
		{
			label: "This Month",
			value: "thisMonth",
			range: [dayjs().startOf("month"), dayjs().endOf("month")],
		},
		{
			label: "Last Month",
			value: "lastMonth",
			range: [
				dayjs().subtract(1, "month").startOf("month"),
				dayjs().subtract(1, "month").endOf("month"),
			],
		},
		{
			label: "This Quarter",
			value: "thisQuarter",
			range: [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
		},
		{
			label: "Last Quarter",
			value: "lastQuarter",
			range: [
				dayjs().subtract(1, "quarter").startOf("quarter"),
				dayjs().subtract(1, "quarter").endOf("quarter"),
			],
		},
		{
			label: "This Year",
			value: "thisYear",
			range: [dayjs().startOf("year"), dayjs().endOf("year")],
		},
		{
			label: "Last Year",
			value: "lastYear",
			range: [
				dayjs().subtract(1, "year").startOf("year"),
				dayjs().subtract(1, "year").endOf("year"),
			],
		},
	];

	// Helper function to get date range display text
	const getDateRangeDisplayText = () => {
		if (!dateRange || !dateRange[0] || !dateRange[1]) return "This Month";

		const preset = datePresets.find((p) => p.value === selectedDatePreset);
		if (preset) return preset.label;

		const start = dateRange[0];
		const end = dateRange[1];
		if (start.isSame(end, "day")) {
			return start.format("MMM D, YYYY");
		}
		return `${start.format("MMM D")} - ${end.format("MMM D, YYYY")}`;
	};

	// Handle date preset change
	const handleDatePresetChange = (presetValue) => {
		const preset = datePresets.find((p) => p.value === presetValue);
		if (preset) {
			setSelectedDatePreset(presetValue);
			setDateRange(preset.range);
		}
	};

	// Handle custom date range change
	const handleDateRangeChange = (dates) => {
		setDateRange(dates);
		setSelectedDatePreset("custom");
	};

	// set document title
	useEffect(() => {
		document.title = "Cloudiva Console | Dashboard";
	}, []);

	useEffect(() => {
		if (context.isLoggedIn) {
			fetchServiceGroups();
			fetchDashboardStats();
		}
	}, [context.isLoggedIn]);

	// Refetch stats when date range changes
	useEffect(() => {
		if (context.isLoggedIn && dateRange && dateRange[0] && dateRange[1]) {
			fetchDashboardStats();
		}
	}, [dateRange, context.isLoggedIn]);

	useEffect(() => {
		if (services.length > 0) {
			handleGroupFilter("all");
		}
	}, [services]);

	const fetchDashboardStats = () => {
		if (!dateRange || !dateRange[0] || !dateRange[1]) return;

		setStatsLoading(true);
		const start = dateRange[0].startOf("day").toISOString();
		const end = dateRange[1].endOf("day").toISOString();

		requestGetStatistics(start, end)
			.then((response) => {
				const stats = response.data.data;
				setDashboardStats({
					revenue: stats.totalRevenue,
					services: stats.activeServices,
					clients: stats.totalClients,
					orders: stats.totalOrders,
					invoices: stats.totalInvoices,
					uptime: 99.9,
				});
			})
			.catch((error) => {
				console.error("Error fetching dashboard stats:", error);
				message.error("Failed to load dashboard statistics");
			})
			.finally(() => {
				setStatsLoading(false);
			});
	};
	const fetchServices = () => {
		requestGetServiceList({
			page: 1,
			limit: 10,
			order: "_id:desc",
		})
			.then((response) => {
				const tempServices = response.data.data;

				setServices(tempServices);
			})
			.catch((error) => {});
	};

	const fetchServiceGroups = () => {
		requestGetServiceGroupList({
			page: 1,
			limit: 100,
			order: "_id:desc",
		})
			.then((response) => {
				const tempServiceGroups = response.data.data;

				setServiceGroups(tempServiceGroups);
				fetchServices();
			})
			.catch((error) => {});
	};

	function checkMatch(input, searchTerm) {
		const regex = new RegExp(searchTerm.split("").join(".*?"), "gi");
		return regex.test(input);
	}

	const handleSearch = (value) => {
		let filteredServices = services;

		// Filter by group
		if (selectedServiceGroup !== "all") {
			filteredServices = filteredServices.filter(
				(service) => service.groupId === selectedServiceGroup
			);
		}

		// Filter by search term
		if (value) {
			filteredServices = filteredServices.filter((service) => {
				return (
					service.name
						.toLowerCase()
						.replace(/[^a-zA-Z0-9]/g, "")
						.includes(value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "")) ||
					checkMatch(service.name, value)
				);
			});
		}

		setMappedServices(filteredServices);
	};

	const handleGroupFilter = (groupId) => {
		setSelectedServiceGroup(groupId);
		let filteredServices = services;

		if (groupId !== "all") {
			filteredServices = services.filter((service) => service.groupId === groupId);
		}

		setMappedServices(filteredServices);
	};

	const getStatusColor = (status) => {
		switch (status) {
			case "success":
				return "#52c41a";
			case "warning":
				return "#faad14";
			case "error":
				return "#f5222d";
			default:
				return "#1890ff";
		}
	};

	return (
		<div>
			{/* Date Range Selector */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col xs={24}>
					<Card
						title="Dashboard Overview"
						loading={statsLoading}
						extra={
							<Space>
								<Select
									value={selectedDatePreset}
									onChange={handleDatePresetChange}
									style={{ minWidth: 150 }}
									disabled={statsLoading}
									options={[
										...datePresets.map((preset) => ({
											label: preset.label,
											value: preset.value,
										})),
										{
											label: "Custom Range",
											value: "custom",
										},
									]}
								/>
								{selectedDatePreset === "custom" && (
									<DatePicker.RangePicker
										value={dateRange}
										onChange={handleDateRangeChange}
										format="MMM DD, YYYY"
										allowClear={false}
										disabled={statsLoading}
									/>
								)}
								<Button
									icon={<PiArrowClockwiseDuotone />}
									onClick={fetchDashboardStats}
									loading={statsLoading}
									title="Refresh statistics"
								/>
								{/* <Tooltip title="Current date range being analyzed">
									<Tag color="blue" style={{ margin: 0 }}>
										📊 {getDateRangeDisplayText()}
									</Tag>
								</Tooltip> */}
							</Space>
						}>
						<Typography.Text type="secondary">
							Select a time period to view dashboard statistics and analytics. Data shown below
							reflects the selected date range.
						</Typography.Text>
					</Card>
				</Col>
			</Row>

			{/* Dashboard Statistics */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title={`Revenue (${getDateRangeDisplayText()})`}
							value={formatCurrency(dashboardStats.revenue)}
							precision={2}
							prefix={<PiMoneyDuotone />}
							valueStyle={{ color: "#3f8600" }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title="Active Services"
							value={dashboardStats.services}
							prefix={<PiGearDuotone />}
							valueStyle={{ color: "#1890ff" }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title={`Clients (${getDateRangeDisplayText()})`}
							value={dashboardStats.clients}
							prefix={<PiUsersDuotone />}
							valueStyle={{ color: "#722ed1" }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title={`Orders (${getDateRangeDisplayText()})`}
							prefix={<PiCubeDuotone />}
							value={dashboardStats.orders}
							valueStyle={{ color: "#52c41a" }}
						/>
					</Card>
				</Col>
			</Row>

			{/* Additional Admin Stats */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title={`Invoices (${getDateRangeDisplayText()})`}
							value={dashboardStats.invoices}
							prefix={<PiCreditCardDuotone />}
							valueStyle={{ color: "#fa8c16" }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card loading={statsLoading}>
						<Statistic
							title="System Uptime"
							prefix={<PiClockDuotone />}
							value={dashboardStats.uptime}
							suffix="%"
							valueStyle={{ color: "#13c2c2" }}
						/>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card>
						<Button
							type="primary"
							icon={<PiPlusDuotone />}
							onClick={() => navigate("/services/add")}
							style={{ width: "100%" }}>
							Add Service
						</Button>
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card>
						<Button
							icon={<PiUsersDuotone />}
							onClick={() => navigate("/customers")}
							style={{ width: "100%" }}>
							Manage Customers
						</Button>
					</Card>
				</Col>
			</Row>

			{/* Quick Actions & Recent Activity */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col xs={24} lg={24}>
					<Card title="Quick Actions" size="small">
						<Row gutter={[8, 8]}>
							<Col>
								<Button type="primary" icon={<PiCreditCardDuotone />}>
									View all
								</Button>
							</Col>
							<Col>
								<Button icon={<PiChartLineDuotone />}>Analytics</Button>
							</Col>
							<Col>
								<Button icon={<PiUsersDuotone />}>Manage Clients</Button>
							</Col>
							<Col>
								<Button icon={<PiHardDrivesDuotone />}>Server Status</Button>
							</Col>
						</Row>
					</Card>
				</Col>
				<Col xs={24} lg={8}>
					<Card title="System Status" size="small">
						<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
							<Badge status="success" />
							<Typography.Text strong>All Systems Operational</Typography.Text>
						</div>
						<div style={{ marginTop: 8 }}>
							<Typography.Text type="secondary">
								{dashboardStats.pendingOrders} pending orders
							</Typography.Text>
						</div>
					</Card>
				</Col>
			</Row>

			{/* Recent Activities */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col span={24}>
					<Card title="Recent Activities" size="small">
						<div style={{ maxHeight: 200, overflowY: "auto" }}>
							{recentActivities.map((activity) => (
								<div
									key={activity.id}
									style={{
										display: "flex",
										alignItems: "center",
										padding: "8px 0",
										borderBottom: "1px solid #f0f0f0",
									}}>
									<div style={{ marginRight: 12 }}>{activity.icon}</div>
									<div style={{ flex: 1 }}>
										<Typography.Text>{activity.message}</Typography.Text>
										<div>
											<Typography.Text type="secondary" style={{ fontSize: 12 }}>
												{activity.time}
											</Typography.Text>
										</div>
									</div>
								</div>
							))}
						</div>
					</Card>
				</Col>
			</Row>

			{/* Service Categories Filter */}
			<Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
				<Col span={24}>
					<Card size="small">
						<div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
							<Typography.Text strong style={{ marginRight: 8 }}>
								Filter:
							</Typography.Text>
							<Button
								key={"all"}
								size="small"
								type={selectedServiceGroup === "all" ? "primary" : "default"}
								onClick={() => handleGroupFilter("all")}>
								All ({services.length})
							</Button>
							{serviceGroups.map((group) => (
								<Button
									key={group._id}
									size="small"
									type={selectedServiceGroup === group._id ? "primary" : "default"}
									onClick={() => handleGroupFilter(group._id)}>
									{group.name} ({services.filter((s) => s.groupId === group._id).length})
								</Button>
							))}
						</div>
					</Card>
				</Col>
			</Row>

			{/* Services Grid */}
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Card
						title="Services"
						size="default"
						extra={
							<Row gutter={[8, 8]}>
								<Col>
									<SearchInput
										placeholder="Cari layanan..."
										onChange={handleSearch}
										style={{ width: 250 }}
									/>
								</Col>
								<Col>
									<Button onClick={() => navigate("/services")}>View All Services</Button>
								</Col>
								<Col>
									<Button
										type="primary"
										icon={<PiPlusDuotone />}
										onClick={() => navigate("/services/add")}>
										Tambah Layanan
									</Button>
								</Col>
							</Row>
						}>
						<Row gutter={[24, 24]}>
							{mappedServices.map((service) => (
								<Col key={service._id} xs={24} sm={12} md={8} lg={6}>
									<Card
										style={{
											cursor: "pointer",
											height: "100%",
											borderColor: service.status === "ACTIVE" ? "#d9d9d9" : "#ffccc7",
										}}
										onClick={() => {
											navigate(`/services/${service._id}/edit`);
										}}
										size="small"
										hoverable>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												gap: 12,
												height: "100%",
											}}>
											<div
												style={{
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
												}}>
												{serviceIcons[service.code] || <PiGearDuotone size={32} color="#fa8c16" />}
												<Tag color={service.status === "ACTIVE" ? "success" : "error"}>
													{service.status === "ACTIVE" ? "Aktif" : "Tidak Aktif"}
												</Tag>
											</div>

											<div>
												<Typography.Text strong>{service.name}</Typography.Text>
												<div style={{ marginTop: 4 }}>
													<Typography.Text type="secondary" style={{ fontSize: 12 }}>
														{service.code}
													</Typography.Text>
												</div>
											</div>

											<div style={{ marginTop: "auto" }}>
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
														alignItems: "center",
														marginBottom: 8,
													}}>
													<Typography.Text strong style={{ color: "#1890ff" }}>
														{service.price}
													</Typography.Text>
													<Typography.Text type="secondary" style={{ fontSize: 12 }}>
														{0}/{0} used
													</Typography.Text>
												</div>
												<Progress
													percent={(0 / 0) * 100}
													size="small"
													strokeColor={{
														"0%": "#108ee9",
														"100%": "#87d068",
													}}
													showInfo={false}
												/>
											</div>
										</div>
									</Card>
								</Col>
							))}
						</Row>

						{mappedServices.length === 0 && (
							<div style={{ textAlign: "center", padding: "40px 0" }}>
								<Typography.Text type="secondary">
									No services found matching your criteria
								</Typography.Text>
							</div>
						)}
					</Card>
				</Col>
			</Row>
		</div>
	);
}

export default DashboardPage;
